module.exports = __webpack_public_path__ + "img/AE.9e2767f1.svg";